import React from 'react'
import './footer.css'
import { FiSend } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";

const Footer = () => {
  return (
    <section className='footer fade-section'>
      <div className="videoDiv">
        {/* SWAP_IMAGE — Replace background-image in footer.css with a real venue photo or video */}
      </div>

      <div className="secContent container">
        <div id='contact' className="contactDiv">
          <div className="text">
            <small>KEEP IN TOUCH</small>
            <h2>Book with us. Reach out via Telegram.</h2>
          </div>

          <div className="inputDiv">
            <a href="https://t.me/BookHookupRoom" className='footerTelegramBtn'>
              TELEGRAM <FiSend className='sendIcon' />
            </a>
          </div>
        </div>

        <div className="footerCard">
          <div className="footerIntro">
            <div className="logoDiv">
              <span className='footerLogo'>Hookup Room</span>
            </div>

            <p className="footerParagraph">
              Where every fantasy finds its place.
            </p>
            <p className="footerDescription" style={{
              fontFamily: 'var(--font-body)',
              fontSize: '13px',
              color: 'var(--text-muted)',
              lineHeight: '1.6',
              marginTop: '1rem',
              maxWidth: '90%'
            }}>
              Hookup Room is quickly becoming a top destination for online reservations, offering a diverse selection of rooms and activities to suit every budget and preference at competitive rates. Managed by Hookup Room Intl., our main office is situated at 125 Deansgate, Manchester M3 2LH, United Kingdom.
            </p>
          </div>

          <div className="footerLinks">

            {/* Group One */}
            <div className="linkGroup">
              <span className="groupTitle">Experience</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Services
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Inclusions
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Privacy
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                FAQ
              </li>
            </div>

            {/* Group Two */}
            <div className="linkGroup">
              <span className="groupTitle">Connect</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Telegram
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Support
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Feedback
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Partners
              </li>
            </div>

            {/* Group Three */}
            <div className="linkGroup">
              <span className="groupTitle">Legal</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Terms
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Privacy Policy
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Disclaimer
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                18+ Policy
              </li>
            </div>
          </div>

          <div className="footerDiv">
            <small>© 2025 Hookup Room · Private & Discreet · 18+ Only</small>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Footer